// PH => Place Holder
export const PH_CODE = "Ingrese código";
export const PH_SEARCH_CODE = "Búesqueda por código";
export const PH_COUPON = "Ingrese cupon";
export const PH_SEARCH_COUPON = "Búesqueda por cupon";
export const PH_ICON = "Ingrese icono";
export const PH_NAME = "Ingrese nombre";
export const PH_NUMBER = "Ingrese número";
export const PH_ORDER = "Orden de presentación";
export const PH_SCHEDULE = "Ingrese horarios de apertura";
export const PH_PRESENTATION = "Ingrese presentación";
export const PH_SHORT_NAME = "Ingrese nombre corto";
export const PH_LONG_NAME = "Ingrese nombre largo";
export const PH_LEVEL = "Nivel del punto";
export const PH_SEARCH_NUMBER = "Búesqueda por número";
export const PH_SEARCH_NAME = "Búesqueda por nombre";
export const PH_POINT_A = "Punto A";
export const PH_POINT_B = "Punto B";
export const PH_INDICATIONS = "Ingrese indicaciones";
export const PH_INVERTED_INDICATIONS = "Ingrese indicaciones invertidas";
export const PH_SEARCH_WORD = "Búsqueda por palabra"

export const PH_SELECT_OPTION = "Selecciona una opción";

export const PH_SIVEX_ID = "Id Sivex";
export const PH_SEARCH_SIVEX_ID = "Búesqueda por id Sivex";
export const PH_SIVEX_CODE = "Código Sivex";
export const PH_COMPONENT_ID = "Id de componente";
export const PH_SEARCH_SIVEX_CODE = "Búesqueda por código Sivex";
export const PH_NEXT_VIEW = "next_view_code";
export const PH_MENU_BACKGROUND = "Fondo para Menu";
export const PH_MENU_LOGO = "Logo para Menu";
export const PH_MENU_SIGNATURE = "Firma para Menu";

export const PH_LANDING_CODE = "Ingrese código de langing";

export const PH_IMAGE = "Ingrese nombre de imagen/banner";
export const PH_TITLE = "Ingrese título";
export const PH_DESCRIPTION = "Ingrese descripción";
export const PH_INCLUDE = "Incluye";
export const PH_WARNING = "Ingrese advertencias";
export const PH_SHORT_DESCRIPTION = "Ingrese la Descripción Corta";
export const PH_LONG_DESCRIPTION = "Ingrese la Descripción Larga";
export const PH_TERMS_AND_CONDS = "Ingrese términos y condiciones";
export const PH_INFO_WINDOW = "Ingrese contenido de la ventana informativa";
export const PH_VALUE = 'Ingrese el Valor'
export const PH_SEARCH_VALUE = 'Búsqueda por valor'
export const PH_PAX_MAX = '00/00'
export const PH_PAX_MIN = '00/00'
export const PH_VERSION_ANDROID = 'Número de versión ANDROID'
export const PH_VERSION_IOS = 'Número de versión en IOS'
export const PH_PAX = 'Pax'
export const PH_EXTRA = 'Extra'
export const PH_NOTE = 'Ingrese la nota'
export const PH_RECOMENDATION = 'Ingrese las Recomendaciones'
export const PH_CAPACITY = 'Ingrese la capacidad'
export const PH_HORARIO = 'Ingrese el horario'
export const PH_HORARIO_DURATION = 'Ingrese la hora de inicio y la duración'
export const PH_DURATION = 'Ingrese la duración'
export const PH_GIFT = 'Regalos'
export const PH_TERM = 'Ingrese el termino'
export const PH_RELATED_FOOD = 'Imagen'
export const PH_GROUP = 'Ingrese el Grupo'
export const PH_VISITOR = 'Visitante'
export const PH_SALES_CODE = 'Código de venta'
export const PH_MINIMUN_STAY_REQUIRED ='Estancia mínima requerida'
export const PH_SET_CONFIRMATION_NUMBER = 'Ingresa el número de confirmación'
export const PH_BODY = "Ingrese el cuerpo";
export const PH_CLOUD_MESSAGE_ID = "Cloud Message ID";
export const PH_DUE_DATE = "Fecha de Vencimiento";
export const PH_START_DATE = "Fecha de Inicio";
export const PH_END_DATE = "Fecha de fin";
export const PH_NATIONALITY = "Ingrese la nacionalidad";
export const PH_IMAGE_DIVIDER = "Ingrese nombre de la imagen de división";
export const PH_UDN_ORDER = "Ingrese el orden de la UDN";
export const PH_EVENT_ORDER = "Ingrese el orden del evento";
export const PH_CLASS_NAME = "Nombre de la clase";
export const PH_OPENING_TIME = "Hora de apertura";
export const PH_CLOSING_TIME = "Hora de cierre";
export const PH_LOGO = "Logo";
export const PH_PHOTO_CODE = "Código de foto";
export const PH_BACKGROUND = "Background";
